import {
  breakDownHostUrl,
  isLoginedToken,
  coinNameToRate,
} from "~/common/js/utils";
import { transLang } from '~/common/js/storeUtil';
import Cookies from "js-cookie";
import { OLD_LOCALES_OBJ_REVERSE } from "~/common/js/const";
// import * as Sentry from "@sentry/vue";
import { axiosClient, setAxiosHeaders } from "~/common/js/axios";
import { defineStore } from "pinia";
import { useAccountStore } from "./account";
import { useTradeStore } from "./trade";
import { useIndividualStore } from "./individual";
import { useCountryStore } from "./country";
import { useMarginStore } from "./margin";
import get from 'lodash/get';
import { COOKIE_NAME, removeLoginInfo } from '~/frontend-shared/helper/login-util';
import { CONFIG_LOCALES_SET, REVERSE_LOCALE_MAP, CURRENCY_MAP, DEFAULT_CURRENCY } from '~/frontend-shared/helper/const';


export const useIndexStore = defineStore("index", {
  state: () => ({
    locale: "en",
    currency: DEFAULT_CURRENCY,
    ip: "",
    userCountryCode: "", // 用户所在地区码
    userName: process.client ? Cookies.get("userName") : null,
    // token: null, // v3 remove
    salt: null, // v3
    walletData: null, // 练手
    isDayMode: false, //日夜间模式
    theme: "dark", // trade主题
    globalThemeSwitcher: false, // 当前页面是否开启了全局主题切换
    globalTheme: "", // 全局主题（不联动trade）
    verificationLimitDialogShow: false, // 显示业务操作等级认证提示
    verificationLimitDialogType: "", // 业务操作等级认证提示的类型
    kycCountryLimitDialogShow: false, // 显示业务地区限制
    mfaVerifyNoticeVisible: false, // kyc开启二次认证
    kycLimitCountryType: "", // 业务限制地区类型, 为区分理财类型而加
    isAppInfoIniting: false, // 标记app正在初始化
    // 币种汇率
    exchangeRate: coinNameToRate,
    // 计价币汇率
    marketCoinRateMap: {},
    // 计价币是否在加载中
    marketCoinRateLoading: true,
    showWelcomeBonus: false, // 是否展示邀请奖励通知
    /** 新kyc认证流程 */
    newVerifyKycFlow: {
      showVerifyKycFlow: false, // 显示kyc认证流程
      targetKycLevel: 2, // 目标kyc级别
      startKycLevel: 0, // 当前kyc级别
      callback: null, // 回调方法
    },
    showDepositGuid: false, // 显示充值引导
    kycLimitCountryCodeList: [],
    // 语言列表
    localeConfigList: [],
    // 下架语言对象
    offlineLocaleConfigMap: {},
    onlineLocaleConfigMap: {},
    // 交易风险限制信息
    tradeRiskLimitInfo: {
      // 是否已经配置过
      hasConfig: false,
      // 配置的时候用户是否已经登录
      isLogin: false,
      // ip定位的国家
      ipCountryCode: "",
      // 用户kyc国家
      kycCountryCode: "",
      // 后端限制的币对和限制国家列表
      riskLimitList: [],
    },
    cookieLocale:useCookie('golang'),
    msgStationClazzList: [],
    // 此处为默认值
    currencyConfigList: [
      CURRENCY_MAP.get('USD'),
      CURRENCY_MAP.get('EUR'),
      CURRENCY_MAP.get('HKD'),
      CURRENCY_MAP.get('CNY'),
      CURRENCY_MAP.get('KRW'),
      CURRENCY_MAP.get('JPY'),
      CURRENCY_MAP.get('VND'),
      CURRENCY_MAP.get('RUB'),
      CURRENCY_MAP.get('TRY'),
      CURRENCY_MAP.get('BRL'),
    ],
    // 法币列表，未来二期通过接口获取
    currencyConfigMap: {},
  }),
  getters: {
    account() {
      return useAccountStore();
    },
    trade() {
      return useTradeStore();
    },
    individual() {
      return useIndividualStore();
    },
    margin() {
      return useMarginStore();
    },
    country() {
      return useCountryStore();
    },
    // 测试用
    isEnglish(state) {
      // console.log('isEnglish', state)
      return state.locale === "en";
    },
    // 测试用
    accountCointype() {
      const accountStore = useAccountStore();
      // console.log('accountStore', accountStore)
      return accountStore.coinType;
    },
    isLogined: (state) => {
      const accountStore = useAccountStore();
      // console.log('store > isLogined', state.userName, state.account.loginName, isLoginedToken())
      return (state.userName || accountStore.loginName) && isLoginedToken();
    },
    isShowGoogle2faDialogCompute(state) {
      const accountStore = useAccountStore();
      let isShow = false;
      let isLoginedShow2fa = accountStore.isClickShow2fa;
      if (accountStore.bindGoogle === false) {
        if (
          accountStore.bindPhone !== true ||
          accountStore.bindEmail !== true
        ) {
          if (isLoginedShow2fa) {
            isShow = true;
          }
        }
      }
      return isShow;
    },
    normalizedLocale() {
      // locale符合'en-US'
      // TODO: transLang have problem
      return transLang(this.locale);
    },
    normalizedLocaleWithCenterLine() {
      // locale符合'en-US'      
      if(CONFIG_LOCALES_SET.has(this.locale)){
        // @ts-ignore have this.locale
        return this.locale;
      }else if(this.cookieLocale && CONFIG_LOCALES_SET.has(this.cookieLocale)){
        // @ts-ignore have this.cookieLocale
        return this.cookieLocale;
      }
      const newLocale = REVERSE_LOCALE_MAP.get(this.locale);
      if(newLocale && CONFIG_LOCALES_SET.has(newLocale)){
        return newLocale;
      }
      return '';
    },
  },
  actions: {
    // 显示充值引导
    SHOW_DEPOSIT_GUID() {
      console.log('SHOW_DEPOSIT_GUID');
      this.showDepositGuid = true;
    },
    // 关闭充值引导
    HIDE_DEPOSIT_GUID() {
      this.showDepositGuid = false;
    },
    // 开始kyc认证流程
    VERIFY_KYC_FLOW_START(data) {
      this.newVerifyKycFlow = {
        ...this.newVerifyKycFlow,
        ...data,
        showVerifyKycFlow: true,
      };
    },
    // 结束kyc认证流程
    VERIFY_KYC_FLOW_END() {
      this.newVerifyKycFlow = {
        showVerifyKycFlow: false,
        targetKycLevel: 2,
        startKycLevel: 0,
        callback: null,
      };
    },
    SET_APP_INFO_INITING(isIniting) {
      this.isAppInfoIniting = isIniting;
    },
    SET_SHOW_WELCOME_BONUS(payload) {
      this.showWelcomeBonus = payload;
    },
    // 显示业务操作等级认证提示
    SHOW_VERIFICATION_LIMIT_DIALOG(type) {
      this.verificationLimitDialogShow = true;
      this.verificationLimitDialogType = type;
    },
    // 关闭业务操作等级认证提示
    HIDE_VERIFICATION_LIMIT_DIALOG() {
      this.verificationLimitDialogShow = false;
    },
    // 设置业务操作等级认证提示的窗口类型
    SET_VERIFICATION_LIMIT_DIALOG_TYPE(type) {
      this.verificationLimitDialogType = type;
    },
    // 显示业务地区限制窗口
    SHOW_KYC_COUNTRY_LIMIT_DIALOG(type) {
      this.kycCountryLimitDialogShow = true;
      this.kycLimitCountryType = type;
    },
    // 显示业务地区限制窗口
    SHOW_KYC_COUNTRY_LIMIT_DIALOG_WIDTH_DATA(extraData: any) {
      console.log("显示业务地区限制窗口", extraData);
      this.kycCountryLimitDialogShow = true;
      if(extraData?.type){
        this.kycLimitCountryType = extraData?.type || "";
      }
      this.kycLimitCountryCodeList = extraData?.countryCodeList || [];
    },
    // 关闭业务地区限制窗口
    HIDE_KYC_COUNTRY_LIMIT_DIALOG() {
      this.kycCountryLimitDialogShow = false;
      this.kycLimitCountryCodeList = [];
      this.kycLimitCountryType = "";
    },
    // 设置用户所在地区码
    SET_COUNTRY_CODE(code: string) {
      this.userCountryCode = code;
    },
    // 设置用户所在地区码
    SET_IP(ip: string) {
      this.ip = ip;
    },
    SHOW_MFA_VERIFY_NOTICE_VISIBLE() {
      this.mfaVerifyNoticeVisible = true;
    },
    HIDE_MFA_VERIFY_NOTICE_VISIBLE() {
      this.mfaVerifyNoticeVisible = false;
    },
    CHANGE_LANG(locale: string) {
      if(this.locale === locale){
        return;
      }
      // console.log("current locale", this.locale, locale);
      // if (LOCALES.includes(locale)) {
      // TODO: 优化 OLD_LOCALES_OBJ_REVERSE 有问题 
      if (
        this.localeConfigList.findIndex((item) => item.locale === locale) >
        -1 ||
        OLD_LOCALES_OBJ_REVERSE[locale]
      ) {
        this.locale = locale;
        if (process.browser || process.client) {
          setAxiosHeaders({
            LOCAL: transLang(locale),
          });
          // TODO 3619
          const token = Cookies.get(COOKIE_NAME.SALT);
          if (token) {
            axiosClient({
              url: '/gw-api/user-center/user/ext/lang',
              method: 'POST',
              data: {
                local: transLang(locale),
              },
            });
          }
        }
        // setAxiosHeaders({
        //   LOCAL: transLang(locale),
        // });
      }
    },
    SET_USER(username) {
      const accountStore = useAccountStore();
      if (!username) {
        const subdomain = `.${breakDownHostUrl(location.hostname)}`;
        Cookies.remove("userName");
        Cookies.remove("userName", { domain: subdomain });
      }
      if (username !== "undefined") {
        // 健壮
        this.userName = username;
      } else {
        this.userName = accountStore.loginName;
      }
      //console.log('store > SET_USER', this.userName)
      // 2022-08-04 lisfan 将app中的username进行隐私处理
      const setUserNamePrivacy = function (name) {
        if (!name || typeof name !== "string") return name;
        // 名称中超过4个且存在连续的4个****时，不处理
        // 名称中不超过4个且存在1个*时，不处理
        if (name.length <= 4 && name.indexOf("*") >= 0) return name;
        if (name.length > 4 && name.indexOf("****") >= 0) return name;
        return name.replace(/([^@]*)(@?.*)/, ($0, $1, $2) => {
          let privacyLength = Math.floor($1.length / 2);
          privacyLength = privacyLength > 4 ? 4 : privacyLength;
          return (
            $1.slice(0, $1.length / 2 - privacyLength / 2) +
            "*".repeat(privacyLength) +
            $1.slice($1.length / 2 + privacyLength / 2) +
            $2
          );
        });
      };
      // Sentry.setUser({
      //   username:
      //     setUserNamePrivacy(this.userName) ||
      //     dwindow.appDeviceID ||
      //     dwindow.device ||
      //     dwindow.localStorage.getItem("getAnonymousID"),
      // });
    },
    SET_CLEAN_INFO() {
      // TODO 3619
      const accountStore = useAccountStore();
      // const subdomain = `.${breakDownHostUrl(location.hostname)}`;
      // Cookies.remove("userName");
      // Cookies.remove("accessToken");
      // Cookies.remove("accessSalt");
      // Cookies.remove("jwtToken");
      // Cookies.remove("api_key");
      // Cookies.remove("token");
      // Cookies.remove("expired_ts");
      // Cookies.remove("userName", { domain: subdomain });
      // Cookies.remove("accessToken", { domain: subdomain });
      // Cookies.remove("accessSalt", { domain: subdomain });
      // Cookies.remove("jwtToken", { domain: subdomain });
      // Cookies.remove("api_key", { domain: subdomain });
      // Cookies.remove("token", { domain: subdomain });
      // Cookies.remove("expired_ts", { domain: subdomain });
      removeLoginInfo();
      this.salt = null;
      // this.token = null;
      accountStore.loginName = null;
      this.userName = null;
      this.trade.buyPrice = null;
      this.trade.buyAmount = null;
      this.trade.sellPrice = null;
      this.trade.sellAmount = null;
      this.trade.orderHistoryList = null;
      this.trade.myexChangeData = null;
      this.trade.orderList = {
        fentrustVOS: null,
      };
      this.trade.currentSymbolWallet = {
        walletVO1: {
          availableBalance: 0,
        },
        walletVO2: {
          availableBalance: 0,
        },
      };
      this.individual.favoritePair = null;
      // 没有用户名时
      // Sentry.setUser({
      //   username:
      //     dwindow.appDeviceID ||
      //     dwindow.device ||
      //     dwindow.localStorage.getItem("getAnonymousID"),
      // });
    },
    // SET_TOKEN(token) {
    //   // TODO 3619
    //   if (token === "undefined") {
    //     if (process.client) {
    //       this.token = Cookies.get("accessToken");
    //     } else {
    //       this.token = token;
    //     }
    //   } else {
    //     this.token = token;
    //   }
    // },
    SET_SALT(salt) {
      this.salt = salt;
    },
    SET_WALLET(walletData) {
      this.walletData = walletData;
    },
    SET_ISDAYMODE(isDayMode) {
      this.isDayMode = isDayMode;
      this.theme = isDayMode ? "light" : "dark";
    },
    SET_GLOBAL_THEME(payload) {
      this.globalTheme = payload;
    },
    SET_GLOBAL_THEME_SWITCHER(payload) {
      this.globalThemeSwitcher = payload;
    },
    /** 设置汇率系统 */
    SET_EXCHANGE_RATE(rateList) {
      rateList?.forEach((item) => {
        this.exchangeRate[item.coinName] = Number(item.latestCoinRate)
      })
    },
    /** 设置交易风险限制信息 */
    SET_TRADE_RISK_LIMIT_INFO(tradeRiskLimitInfo) {
      this.tradeRiskLimitInfo = tradeRiskLimitInfo;
    },
    /** 设置计价币种及对应的汇率信息 */
    SET_MARKET_COIN_RATE_MAP(marketCoinRateMap) {
      this.marketCoinRateMap = marketCoinRateMap
      this.marketCoinRateLoading = false
    },
    /** 设置法币单位列表 */
    SET_CURRENCY_CONFIG_LIST (currencyConfigList = []) {
      this.currencyConfigList = currencyConfigList
    },
    /** 设置法币单位 */
    SET_CURRENT_CURRENCY (currency = DEFAULT_CURRENCY) {
      this.currency = currency
    },
    syncLocaleStore (data) {
      const localeConfigList = get(data, 'configLocaleDtoList', []);
      const offlineLocaleDtoList = get(data, 'offlineLocaleDtoList', []);
      this.localeConfigList = localeConfigList
      this.onlineLocaleConfigMap = localeConfigList.reduce((map, item) => {
        map[item.locale] = item
        return map
      }, {});
      this.offlineLocaleConfigMap = offlineLocaleDtoList?.reduce((map, item) => {
        map[item.locale] = item
        return map
      }, {});
    },
    async logout() {
      // TODO 3619
      // const subdomain = `.${breakDownHostUrl(location.hostname)}`;
      // commit("SET_USER", null);
      this.SET_USER(null);
      removeLoginInfo()
      // Cookies.remove("userName");
      // Cookies.remove("accessToken");
      // Cookies.remove("accessSalt");
      // Cookies.remove("jwtToken");
      // Cookies.remove("api_key");
      // Cookies.remove("token");
      // Cookies.remove("expired_ts");
      // Cookies.remove("userName", { domain: subdomain });
      // Cookies.remove("accessToken", { domain: subdomain });
      // Cookies.remove("accessSalt", { domain: subdomain });
      // Cookies.remove("jwtToken", { domain: subdomain });
      // Cookies.remove("api_key", { domain: subdomain });
      // Cookies.remove("token", { domain: subdomain });
      // Cookies.remove("expired_ts", { domain: subdomain });
      await axiosClient({
        method: "POST",
        url: "/gw-api/user-center/token/logout",
      });
    },
    /** 设置交易风险限制列表 */
    async setTradeRiskLimitInfo() {
      const accountStore = useAccountStore();
      const tradeRiskLimitInfo = this.tradeRiskLimitInfo;
      // 如果store中已经设置过了，就不再请求了
      if (tradeRiskLimitInfo?.hasConfig) {
        return;
      }
      const listRes = await axiosClient({
        url: "/gw-api/ds/find_symbol_alert",
      });
      if (!listRes?.success || !listRes?.data?.list?.length) {
        tradeRiskLimitInfo.hasConfig = true;
        // commit("SET_TRADE_RISK_LIMIT_INFO", tradeRiskLimitInfo);
        this.SET_TRADE_RISK_LIMIT_INFO(tradeRiskLimitInfo);
        return;
      }
      // const requestIp = await axiosClient({
      //   url: '/gw-api/user-center/current-ip',
      // })
      // const ipCountryCode = get(requestIp, ['data', 'countryCode'], '');
      // commit("SET_TRADE_RISK_LIMIT_INFO", {
      //   ...tradeRiskLimitInfo,
      //   hasConfig: true,
      //   ipCountryCode: this.userCountryCode,
      //   // store.account.country 已经有了 就不需要重复取
      //   kycCountryCode: accountStore.country,
      //   riskLimitList: listRes?.data?.list || [],
      // });
      this.SET_TRADE_RISK_LIMIT_INFO({
        ...tradeRiskLimitInfo,
        hasConfig: true,
        ipCountryCode: this.userCountryCode,
        // store.account.country 已经有了 就不需要重复取
        kycCountryCode: accountStore.country,
        riskLimitList: listRes?.data?.list || [],
      });
    },
    /** 获取站内信类别 */
    setMsgStationClazz() {
      if(!this.isLogined){
        this.msgStationClazzList = [];
        return;
      }

      axiosClient({
        url: '/gw-api/notification/msg/station/clazz',
        method: 'GET',
        params: {
          local: transLang(this.locale),
        },
      }).then((resp: any) => {
        if (resp.success) {
          this.msgStationClazzList = resp.data?.list || [];
        }
      });
    },

  },
   
});
